(function ($, Global) {
    var urlParams = new UrlParams();

	var ArchivesPage = function (model) {
		this.model = model;
	}

	ArchivesPage.prototype.initEvents = function () {
		this.publishers();
		this.subscribers();
	}

	ArchivesPage.prototype.publishers = function () {
		var self = this;

		$(document).ready(function () {
			var hash = $.URLHash();

			if (hash === 'browse') {
				$('.page-archives .mask').addClass('visible');
			}	
		});

		$(document).on('change', '.archives-filters input, .archives-filters select', function () {
			$.Topic('archives-filters-change').publish(this);
        });
	}

	ArchivesPage.prototype.subscribers = function () {
		var self = this;

        $.Topic('archives-filters-change').subscribe(function (el) {
            var isLink = el.tagName === 'A';
			var $el = $(el);
            var filterName = $el.data('filter');

            $('.page-archives .mask').removeClass('visible');

            if (filterName == 'Month' && !urlParams.getParam('Year')) {
                var filterYearValue = isLink ? $('.filters-mobile [data-filter="Year"]').data('value') : $('.filters-top [data-filter="Year"]').val();
                urlParams.setParam('Year', filterYearValue);
            }

            $.Topic('loader-show').publish('.page');

			self.model.updateEdition(isLink ? $el.data('value') : $el.val(), filterName);
		});
	}

	window.ArchivesPage = ArchivesPage;
}(jQuery, window));